import React from 'react';
import { useTranslation } from 'react-i18next';
import { EyeOff } from 'lucide-react';

interface Props {
    onDismiss: () => void;
}

const OnboardingDismissButton: React.FC<Props> = ({ onDismiss }) => {
    const { t } = useTranslation();

    return (
        <button
            onClick={onDismiss}
            className="flex items-center gap-1.5 rounded-md border border-gray-200 bg-white px-3 py-1.5 text-xs font-medium text-gray-500 transition-colors hover:border-gray-300 hover:text-gray-700"
        >
            <EyeOff size={13} />
            {t('onboarding.dontShowAgain')}
        </button>
    );
};

export default OnboardingDismissButton;
